export const ROLES = [
    { value: 'GROUP_ADMIN', label: 'str.user.role.group.admin' },
    { value: 'ADMIN', label: 'str.user.role.admin' },
    { value: 'MANAGER', label: 'str.user.role.manager' },
    { value: 'OPERATOR', label: 'str.user.role.operator' },
    { value: 'AUDITOR', label: 'str.user.role.auditor' },
]
